class FostrProductGrid extends HTMLElement {
  static get observedAttributes () {
    return ['layout', 'view']
  }

  get layout () {
    return this.getAttribute('layout')
  }

  set layout (value) {
    return this.setAttribute('layout', value)
  }

  get view () {
    return this.getAttribute('view') === 'true'
  }

  set view (value) {
    return this.setAttribute('view', value)
  }

  constructor () {
    super()

    // Elements
    this.productGrid = this.querySelector('#product-grid')
    this.productCards = this.querySelectorAll('fostr-product-card')
    this.layoutSwitchers = document.querySelectorAll('fostr-layout-switcher')
    this.viewSwitcher = document.querySelector('fostr-view-switcher')

    this.peekProductCards()
  }

  async connectedCallback () {
    // Restore settings from localStorage, if they exist
    this.restoreSettings()

    // Update components
    this.updateComponents()
  }

  async updateComponents () {
    const promises = [this.waitForComponentsToLoad(this.productCards)]
    if (this.layoutSwitchers) { promises.push(this.waitForComponentsToLoad(this.layoutSwitchers)) }
    if (this.viewSwitcher) { promises.push(this.waitForComponentsToLoad([this.viewSwitcher])) }

    await Promise.all(promises)

    this.productCards.forEach(productCard => productCard.update())
    if (this.layoutSwitchers) { this.layoutSwitchers.forEach(layoutSwitcher => layoutSwitcher.update()) }
    if (this.viewSwitcher) this.viewSwitcher.update()

    switch (this.layout) {
      case 'list':
        // List
        this.querySelector('#product-grid').classList.replace(
          'grid--2-col',
          'grid--1-col',
        )
        break

      default:
        // Grid
        this.querySelector('#product-grid').classList.replace(
          'grid--1-col',
          'grid--2-col',
        )
        break
    }
  }

  async waitForComponentsToLoad (elements) {
    const promises = [...elements].map(node =>
      customElements.whenDefined(node.localName),
    )

    return await Promise.all(promises)
  }

  restoreSettings () {
    const sessionLayout = localStorage.getItem('fostr-layout')
    const sessionView = localStorage.getItem('fostr-view')

    if (sessionLayout && sessionView) {
      if (sessionLayout !== this.layout) {
        this.layout = sessionLayout
      }
      if (sessionView === 'true' && !this.view) {
        this.view = true
      }
    }
  }

  persistSettings () {
    localStorage.setItem('fostr-layout', this.layout)
    localStorage.setItem('fostr-view', this.view)
  }

  attributeChangedCallback (attrName, oldVal, newVal) {
    // Ignore the first application of the attribute while initialising the element
    if (oldVal === null) return

    // Update components
    this.updateComponents()

    // Persist settings to sessionStorage
    this.persistSettings()
  }

  peekProductCards () {
    if (window.innerWidth > 749 || sessionStorage.getItem('BAO-card-peek')) return

    const productCard1 = document.querySelector('fostr-product-grid .grid__item:nth-child(1) fostr-product-card')
    const productCard2 = document.querySelector('fostr-product-grid .grid__item:nth-child(2) fostr-product-card')

    if (productCard1 === null) return

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver((entry) => {
      // eslint-disable-next-line dot-notation
      if (entry[0]['intersectionRatio'] !== 0) {
        setTimeout(() => {
          productCard1.classList.add('fostr-card-wrapper--animate')
        }, 1500)

        if (productCard2 !== null) {
          setTimeout(() => {
            productCard2.classList.add('fostr-card-wrapper--animate')
          }, 2500)
        }

        sessionStorage.setItem('BAO-card-peek', 'true')
      }
    })

    observer.observe(productCard1)
  }
}

customElements.define('fostr-product-grid', FostrProductGrid)
